import TextField from "@/components/site-builder/TextField";
import type { VideoGalleryBlock, VideoGalleryModuleType } from "../types";
import BaseVideoBlock from "../BaseVideoBlock";
import { DisplayVariant } from "../constants";
import Player from "../Player";

export interface MapperProps {
  module: VideoGalleryModuleType;
  block: VideoGalleryBlock;
}

export default function Mapper(props: MapperProps) {
  const { module, block } = props;
  const {
    style: {
      display: { displayVariant },
    },
    body: { aspectRatio, mediaDisplayVariant },
  } = module;

  const mediaContent = (
    <Player
      block={block}
      aspectRatio={aspectRatio}
      openIn={mediaDisplayVariant}
    />
  );

  switch (displayVariant) {
    case DisplayVariant.Variant1:
      return (
        <BaseVideoBlock>
          {mediaContent}
          <TextField type="text-large" field={block.title} />
        </BaseVideoBlock>
      );

    case DisplayVariant.Variant2:
      return <BaseVideoBlock>{mediaContent}</BaseVideoBlock>;

    default:
      return null;
  }
}
